<template>
  <el-dialog :visible.sync="visible" title="充电时段电量详情" width="1400px" :close-on-click-modal="false" append-to-body
    @opened="loadData" @closed="clearData">
    <div v-loading="loading" class="charge-detail-body">
      <el-form size="small" inline class="time-range-form">
        <el-form-item label="时间区间：">
          <el-date-picker v-model="timeRange" type="datetimerange" range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
            style="width: 380px" @change="onTimeRangeChange" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="loadData">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="chart-wrap">
        <ChargeChart :chargeInfos="chargeInfos" :show-card="false" :height="320" />
      </div>
      <div v-if="!loading && (!chargeInfos || !chargeInfos.length)" class="no-data-tip">
        该时间段内暂无电量数据
      </div>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment";
import ChargeChart from "@/components/ChargeChart";
import { getChargingChargeInfos } from "@/api";
import { DateUtil } from "@/util";

export default {
  name: "ChargingRecordChargeDetailModal",
  components: {
    ChargeChart
  },
  data() {
    return {
      visible: false,
      loading: false,
      driverId: null,
      driverNo: "",
      timeRange: null,
      chargeInfos: []
    };
  },
  methods: {
    /**
     * 打开弹框，传入充电记录行数据（含 driverId、startTime、endTime）
     * 默认时间范围为充电开始前 30 分钟至充电结束后 30 分钟
     */
    open(row) {
      if (!row || row.driverId == null) {
        this.$message.warning("缺少司机信息");
        return;
      }
      this.driverId = row.driverId;
      this.driverNo = row.driverNo || "";
      const startStr = row.startTime ? String(row.startTime).trim() : "";
      const endStr = row.endTime ? String(row.endTime).trim() : DateUtil.getDateTimeStr(0);
      if (startStr) {
        const start = moment(startStr.replace(/-/g, "/")).subtract(360, "minutes");
        const end = moment(endStr.replace(/-/g, "/")).add(360, "minutes");
        this.timeRange = [start.format("YYYY-MM-DD HH:mm:ss"), end.format("YYYY-MM-DD HH:mm:ss")];
      } else {
        this.timeRange = null;
      }
      this.visible = true;
    },
    onTimeRangeChange() {
      if (this.timeRange && this.timeRange.length === 2 && this.driverId != null) {
        this.loadData();
      }
    },
    async loadData() {
      if (this.driverId == null || !this.timeRange || this.timeRange.length !== 2) {
        return;
      }
      const [startTime, endTime] = this.timeRange;
      this.loading = true;
      try {
        const res = await getChargingChargeInfos(this.driverId, startTime, endTime);
        this.chargeInfos = res.data || [];
      } catch (e) {
        this.chargeInfos = [];
      } finally {
        this.loading = false;
      }
    },
    clearData() {
      this.driverId = null;
      this.driverNo = "";
      this.timeRange = null;
      this.chargeInfos = [];
    }
  }
};
</script>

<style scoped>
.charge-detail-body {
  min-height: 200px;
}

.time-range-form {
  margin-bottom: 16px;
}

.chart-wrap {
  margin-top: 8px;
}

.no-data-tip {
  text-align: center;
  color: #909399;
  padding: 24px 0;
  font-size: 14px;
}
</style>
